// Angular
import {Component, Input, Output, EventEmitter, OnInit} from "@angular/core";

// Afidium
import { ITask } from "libraries/service/resources/booking-task-resource/ITask";
import { PROCESSING_STATUSES } from "app_sasha/shared/wordings/processing";
import { ILabels } from "libraries/interfaces/ILabels";
import { IQualityCheckResponse } from "libraries/service/resources/model/booking/air/IAirBookingResponse";
import { Yii } from "libraries/interfaces/Yii";

@Component({
    selector: 'processing-task',
    template: `
        <div class="col-to-row-s-tb">
            <booking class="flex-3"
                     [booking]="task.booking"
                     [processingId]="processingId"
                     [noBookingLabel]="noBookingLabel"></booking>
            <processing-task-status class="flex-1 status-container col-to-row-s-tb stretch"
                                    [task]="task"
                                    (onClickOnRetry)="onRetry.emit($event)">
            </processing-task-status>
        </div>
        <div class="col-to-row-s-tb">
            <booking-quality-control-data *ngIf="task.response"
                                          [booking]="task.response"
                                          [isQualityCheckResponse]="true"></booking-quality-control-data>
        </div>
    `,
    styles: [`
        div {
            align-items: flex-start;
        }

        booking {
            padding: 10px;
        }

        processing-task-status {
            flex: 1;
            padding: 10px 0 10px 10px;
        }

        .processing {
            color: #505050;
            background: #cbcbcb;
            border: 1px solid #828282;
        }

        .center {
            display: flex;
            align-items: center;
        }

        quality-check-result {
            flex: 1;
            margin-bottom: 15px;
        }
    `]
})
export class ProcessingTaskComponent{

    /**
     * in case we open the booking from a processing page, modify the url and breadcrumb
     */
    @Input()
    public processingId: number;

    @Input()
    public task: ITask;

    @Input()
    public processingType: string;

    @Output()
    public readonly onRetry: EventEmitter<ITask> = new EventEmitter();

    public readonly labels: ILabels = PROCESSING_STATUSES;

    public readonly noBookingLabel: string = Yii.t('wui-sasha-js', "Le traitement a échoué et n'a retourné aucun dossier.");

    public getQualityCheckResponse(): IQualityCheckResponse {
        return this.task ? this.task.response as IQualityCheckResponse : null;
    }
}
